import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

//import * as $ from 'jquery'; window["$"] = $; window["jQuery"] = $;


if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('./service-worker.js').then((reg: ServiceWorkerRegistration) => {
        reg.onupdatefound = () => {
          console.log(`service worker onupdatefound`);
          const installingWorker = reg.installing;
          installingWorker.onstatechange = () => {
            switch (installingWorker.state) {
              case 'installed':
                console.log(`new service worker installed`);
                // if (navigator.serviceWorker.controller) {
                //   window.location.reload();
                // }
                break;
            }
          };
        };


        let refreshing = false;
        // detect controller change and refresh the page
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!refreshing) {
            console.log(`controll change, window about to reload`);
            window.location.reload();
            refreshing = true;
          }
        });

      });

    }


  })
  .catch(err => console.log(err));
